/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MFieldItemComponent as ɵa} from './field-item.compontent';